import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <ContactSection />
        <CarouselSection />
        <AppSection />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <RankingSection />
        <CardsSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}